module.exports = " <div v-bind:style=\"{'display': display ? '' : 'none'}\"> <div class=modal-header> <h4 class=header-title>予約削除</h4> </div> <div class=modal-body> 予約を削除しますか？ </div> <div class=modal-footer> <button class=\"btn btn-default\" @click=back>戻る</button> <button class=\"btn btn-danger\" @click=waitFor(remove())>削除</button> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/reservations/reservations-table/modal-form/remove.vue
// module id = 275
// module chunks = 0